import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

const Toolbar = ({ locale }) => {
    const changeLng = (event) => {
        locale.value = event.target.value;
    };
    return (
        <div>
            <select className="form-control mr-sm-2" value={locale.value} onChange={changeLng}>
                <option value="en">EN</option>
                <option value="fr">FR</option>
                <option value="de">DE</option>
                <option value="de-CH">DE-CH</option>
            </select>
        </div>);
};


Toolbar.propTypes = {
    locale: PropTypes.object.isRequired,
};

export default inject('locale')(observer(Toolbar));
